/* 引入全局组件   
    配置方法：
        1、在项目的 components 文件夹创建 “xxxx.vue”文件；
        2、在组件中可以直接使用  <xxx/>
    注：命名第一个字母请使用大写，并使用驼峰命名
*/

import Vue from 'vue';
let models = require.context('../components', false, /\.vue$/);

models.keys().forEach(item => {
    let startNum = item.indexOf("/")+1,
        endNum = item.lastIndexOf("."),
        name = item.slice(startNum,endNum);
        if(name != "index") {
            Vue.use({
                install: function(Vue) {
                    Vue.component(name, models(item).default);
                }
            });
        } 
})


// WEBPACK FOOTER //
// ./src/pages/index/components/index.js